import type { PageEnvelope } from '../../components';

/**
 * The .NET `Paged<T>` wire shape (page/pageSize) returned by the block-085
 * `/site/users` list and the NOTIF `/site/notification-templates` +
 * `/site/notifications` lists — distinct from the `{ items, total, take, skip }`
 * envelope the slice-16/21 console lists use. {@link toEnvelope} adapts it to
 * the shared `PagedTable` (skip/take), and {@link toPageParams} converts a
 * PagedTable skip/take pair back into the 1-based page/pageSize the endpoints
 * read. See TD (paging-convention split) in the slice-20 completion log.
 */
export interface NetPaged<T> {
  items: T[];
  totalCount: number;
  page: number;
  pageSize: number;
  hasMore: boolean;
}

export function toEnvelope<T>(paged: NetPaged<T>): PageEnvelope<T> {
  return {
    items: paged.items,
    total: paged.totalCount,
    take: paged.pageSize,
    skip: (paged.page - 1) * paged.pageSize,
  };
}

export function toPageParams(skip: number, take: number): { page: number; pageSize: number } {
  const pageSize = take > 0 ? take : 25;
  return { page: Math.floor(skip / pageSize) + 1, pageSize };
}
